

















import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldSelect'

  vue:
    props: ['value', 'errors', 'options', 'placeholder', 'filterable', 'disabled']

    data: ->
      value_: @value

    computed:
      _filterable: ->
        return @filterable if @filterable?
        true

    methods:
      hiInputChange: (value) ->
        @$emit 'input', value
        @$emit 'change', value

export default VueOptions.vue settings
